import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "DepStatistics";

export const postDepStatisticsReport = createAsyncThunk(
  `${namespace}/postDepStatistics`,
  async (body, { rejectWithValue }) => {
    const api = "departmentstatistics2";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postDepStatisticsExcel = createAsyncThunk(
  `${namespace}/postDepStatisticsExcel`,
  async (body, { rejectWithValue }) => {
    const api = "depstatisticexcel";
    const opt = {
      body:body ,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  depStatisticsReport: {
    month: "",
    year: "",
    // fromdate: new Date(Date.now() - 86400000).toISOString().slice(0, 10),
    // todate: new Date().toISOString().slice(0,10),
    is_manager: 0
  },
  report: []
};

const depStatisticsSlice = createSlice({
  name: "depStatistics",
  initialState,
  reducers: {
    updateDepStatisticsReport(state, action) {
      return { ...state, depStatisticsReport: action.payload };
    },
    resetDepStatisticsReport(state, action){
      return{...state, depStatisticsReport: initialState.depStatisticsReport};
    },
  },
  extraReducers:{
      [postDepStatisticsReport.pending]: (state, action) => {
        state.loading = true;
      },
      [postDepStatisticsReport.fulfilled]: (state, action) => {
        state.loading = false;
        state.report = action.payload;
        console.log(action.payload);
      },
      [postDepStatisticsReport.rejected]: (state, action) => {
        state.error = true;
        console.error(action.payload);
      },
      [postDepStatisticsExcel.pending]: (state, action) => {
        state.loading = true;
      },
      [postDepStatisticsExcel.fulfilled]: (state, action) => {
        state.loading = false;
        console.log(action.payload);
      },
      [postDepStatisticsExcel.rejected]: (state, action) => {
        state.error = true;
        console.error(action.payload);
      },
  }
});

export const {updateDepStatisticsReport, resetDepStatisticsReport} = depStatisticsSlice.actions;
export default depStatisticsSlice.reducer;
